export enum PRACTICESTATES {
    START_GAME = "START_PRACTICE",
    QUESTIONS = "QUESTIONS",
    SHOW_QUESTION = "SHOW_QUESTION",
    RESTART_QUESTION = "RESTART_QUESTION",
    ENDGAME = "ENDGAME",
}

interface Practice {
    state: PRACTICESTATES;
    questions: any;
    question : string;
    options : string[];
    duration: number,
    questionNumber: number,
    correctAnswers: number,
    timeToAnswer: number,
    startTime: number,
}

export default Practice;
